import { render, staticRenderFns } from "./FieldExerciseAnswers.vue?vue&type=template&id=42718e59&scoped=true"
import script from "./FieldExerciseAnswers.vue?vue&type=script&lang=js"
export * from "./FieldExerciseAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42718e59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42718e59')) {
      api.createRecord('42718e59', component.options)
    } else {
      api.reload('42718e59', component.options)
    }
    module.hot.accept("./FieldExerciseAnswers.vue?vue&type=template&id=42718e59&scoped=true", function () {
      api.rerender('42718e59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldExerciseAnswers.vue"
export default component.exports